import { base } from './base';

export const jonkoping = Object.assign({}, base, {});
